import clsx from "clsx";

export interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children?: React.ReactNode;
  variant?:
    | "primary"
    | "secondary"
    | "danger"
    | "success"
    | "warning"
    | "outline-danger"
    | "outline-warning"
    | "outline-success"
    | "outline-primary"
    | "ghost"
    | "link"
    | "backLink";
  square?: boolean;
  paddingLess?: boolean;
  icon?: JSX.Element;
  iconPosition?: "left" | "right";
  disabled?: boolean;
  extraClassName?: string;
  loading?: boolean;
}
const Button = ({
  className,
  children,
  variant = "primary",
  square,
  disabled,
  icon,
  iconPosition = "right",
  paddingLess,
  type = "button",
  extraClassName,
  loading = false,
  ...props
}: IButtonProps) => {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled || loading}
      className={clsx(
        "flex justify-center items-center cursor-pointer font-IRANSansBold  font-medium text-base whitespace-nowrap min-h-[46px]",
        variant === "primary" &&
          "bg-blue-600 text-white hover:bg-blue-700 focus:bg-blue-700 disabled:bg-gray-500",
        variant === "secondary" &&
          "border-[1.4px] border-solid border-blue-600 bg-white text-blue-600 hover:bg-blue-200 focus:bg-blue-300disabled:border-gray-500 disabled:text-gray-500 disabled:hover:bg-white",
        variant === "danger" && "bg-danger-600 hover:bg-danger-700 text-danger-200 ",
        variant === "success" && "bg-success-500 hover:bg-success-700 text-success-200 ",
        variant === "outline-danger" &&
          " text-danger-500 border border-danger-500 hover:text-white hover:bg-danger-700",
        variant === "outline-success" &&
          " text-success-500 border border-success-500 hover:text-white hover:bg-success-700",
        variant === "outline-warning" &&
          "bg-white text-orange-400 border border-orange-500 hover:text-white hover:bg-orange-500",
        variant === "outline-primary" &&
          "text-orange-500 border border-orange-500 hover:text-white hover:bg-orange-700",
        variant === "ghost" &&
          "text-[#7D96B8] bg-white border-2  focus:border-blue-1 focus:text-blue-1  border-[#7D96B8] disabled:text-blue-gray-300 disabled:hover:bg-white",
        variant === "link" &&
          "text-blue-600 hover:bg-blue-200 focus:bg-blue-300 disabled:text-blue-gray-300 disabled:hover:bg-white",
        !square && "rounded-md",
        !paddingLess && "py-1 px-3",
        disabled && "disabled:text-gray-300 disabled:hover:bg-gray-400 disabled:bg-gray-600",
        !disabled && "transition active:scale-95",
        extraClassName && extraClassName
      )}
    >
      {icon && iconPosition === "right" && icon}
      {children && (
        <div
          className={`font-IRANSansBold font-medium ${iconPosition === "right" && "mr-1"} ${
            iconPosition === "left" && "ml-1"
          }`}
        >
       {loading ? 'در حال ارسال' : children}
        </div>
      )}
      {loading && (
        <div className="mx-2">
          <svg
            className="animate-spin mr-1 h-3 w-3 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      )}
      {icon && iconPosition === "left" && icon}
    </button>
  );
};

export default Button;
